import { $ } from '../Framework';
function toSearchParams(body) {
    if (body instanceof URLSearchParams)
        return body;
    const searchParams = new URLSearchParams();
    Object.entries(body).forEach(([key, value]) => {
        if (value === null || value === undefined)
            return;
        if (Array.isArray(value)) {
            value.forEach((arrayValue) => {
                if (arrayValue !== null && arrayValue !== undefined)
                    searchParams.append(key, String(arrayValue));
            });
            return;
        }
        searchParams.append(key, String(value));
    });
    return searchParams;
}
function appendQueryToUrl(url, searchParams) {
    const queryString = searchParams.toString();
    if (!queryString)
        return url;
    const hashIndex = url.indexOf('#');
    const hash = hashIndex >= 0 ? url.slice(hashIndex) : '';
    const baseUrl = hashIndex >= 0 ? url.slice(0, hashIndex) : url;
    const separator = baseUrl.includes('?') ? '&' : '?';
    return baseUrl + separator + queryString + hash;
}
const Network = {
    httpRequest: async function (parameters) {
        const responseType = parameters.responseType || parameters.dataType || 'text';
        const method = parameters.method || parameters.type || 'GET';
        let response;
        const requestInit = {
            method: method
        };
        let requestUrl = parameters.url;
        if (typeof parameters.body !== 'undefined') {
            const requestBody = toSearchParams(parameters.body);
            if (method === 'GET') {
                requestUrl = appendQueryToUrl(requestUrl, requestBody);
            }
            else {
                requestInit.body = requestBody;
            }
        }
        if (requestInit.body) {
            requestInit.headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
        }
        try {
            response = await fetch(requestUrl, requestInit);
            const text = await response.text();
            if (!response.ok) {
                const httpError = new Error('HTTP error ' + response.status + ' (' + response.statusText + ')');
                httpError.status = response.status;
                httpError.responseText = text;
                throw httpError;
            }
            let parsedData;
            if (responseType === 'text') {
                parsedData = text;
            }
            else if (responseType === 'json') {
                parsedData = JSON.parse(text);
            }
            else if (responseType === 'html') {
                parsedData = $.parseHTML(text);
            }
            else {
                throw new Error('Unsupported responseType: ' + responseType);
            }
            if (parameters.success)
                parameters.success(parsedData, response);
            return parsedData;
        }
        catch (error) {
            if (parameters.error)
                parameters.error(error, response);
            throw error;
        }
    }
};
export function addNetwork(base) {
    return Object.assign(base, Network);
}
